import * as _ from "lodash";
import * as $ from "jquery";

import { render, unmountComponentAtNode } from "react-dom";
import React, { useState, useEffect, useRef } from "react";

import { BalconyGroup, BalconyInfo, BalconyPanel } from "./balconyInfo";
import { MeasurementSteps } from "./balconyMeasument";
import { CopySteps } from "./balconyCopy";
import { BalconyPropertiesPanel } from "./balconyPropertiesPanel";
import { StartCreation } from "./balconyCreation";

// eslint-disable-next-line
let removeBalcony = async () => { };

export interface Balcony {
    id: string;
    text: string;
}

interface BalconyListProps {
    balconies: BalconyGroup[];
    selectedBalconyId: number;
    startBalconyCreation: () => void;
    removeBalcony: () => void;
    removeAllBalconies: () => void;
    selectBalcony: (id: number) => void;
    startMeasurementCreation: () => void;
    startCopying: () => void;
    openProperties: () => void;
}

interface BalconyRowProps {
    key: number;
    balcony: BalconyGroup;
    selected: boolean;
    onClick: () => void;
    //openProperties: (id: number) => void;
}

const BalconyList = (props: BalconyListProps) => {
    return (
        <>
            <ul className="plain-list" style={{ height: "calc(100% - 360px)", minHeight: "200px", overflow: "hidden", overflowY: "scroll" }}>
                {props.balconies.map(b => {
                    return <BalconyRow key={b.id} balcony={b} selected={b.id === props.selectedBalconyId}
                        onClick={() => {
                            props.selectBalcony(b.id);
                        }} />;
                })}
            </ul>
            <button className="btn btn-primary" onClick={props.startBalconyCreation}>
                Add
            </button>
            <button className="btn btn-primary ml-1" onClick={props.removeBalcony} disabled={props.selectedBalconyId === null}>
                Remove
            </button>
            <button className="btn btn-primary ml-1" onClick={props.startMeasurementCreation} disabled={props.selectedBalconyId === null}>
                Measurements
            </button>
            <button className="btn btn-primary ml-1" onClick={props.openProperties} disabled={props.selectedBalconyId === null}>
                Edit
            </button>
            <button className="btn btn-primary ml-1" onClick={props.startCopying} disabled={props.selectedBalconyId === null}>
                Copy
            </button>
        </>
    );
}

const BalconyRow = (props: BalconyRowProps) => {
    const rowRef = useRef(null);

    useEffect(() => {
        if (props.selected && rowRef.current) {
            rowRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }, [props.selected]);

    return (
        <li ref={rowRef} className="comment-list-item" style={props.selected ? { border: "solid white" } : null} onClick={props.onClick}>
            <div className="comment-list-label">{props.balcony.propertyValues["BalconyLine"]} - {props.balcony.propertyValues["Level"]} - {props.balcony.propertyValues["Apartment"]}
                {/*<button className="btn btn-info btn-sm float-right"*/}
                {/*    onClick={(e) => {*/}
                {/*        //e.stopPropagation();*/}
                {/*        props.openProperties();*/}
                {/*    }}*/}
                {/*    style={{ height: "60%" }}>Edit*/}
                {/*</button>*/}
            </div>
        </li>
    );
}

enum BalconyStep {
    None,
    Add,
    Measurement,
    Copy
}

interface GlassUiProps {
    viewer: Autodesk.Viewing.GuiViewer3D;
    balconyInfo: BalconyInfo;
    selectedBalconyId: number;
}

function GlassUi(props: GlassUiProps) {
    const propsPanel = useRef<BalconyPropertiesPanel>(null);
    const panelsModelId = useRef<number>(null);
    const infoModelId = useRef<number>(null);

    const selectedBalcony = useRef<number>(null);

    const ownEvent = useRef<boolean>(false);

    const [balconies, setBalconies] = useState(props.balconyInfo.groups.slice());
    const [selectedBalconyId, setSelectedBalconyId] = useState<number>(null);
    const [step, setStep] = useState(BalconyStep.None);

    const sleep = (time) => {
        return new Promise((resolve) => {
            setTimeout(resolve, time);
        });
    }

    const startBalconyCreation = () => {
        setSelectedBalconyId(null);
        removeMeasurements();
        setStep(BalconyStep.Add);
    }

    const closeWizard = async () => {
        //await removeMeasurements();
        await selectBalcony(selectedBalcony.current);
        setStep(BalconyStep.None);
    }

    const selectBalcony = async (id: number, ignorePropsPanel: boolean = false) => {
        selectedBalcony.current = id;

        if (id != null) {
            setStep(BalconyStep.None);

            await initBalconyMeasurements(id);

            setSelectedBalconyId(id);

            if (!ignorePropsPanel) {
                if (propsPanel.current?.isVisible()) {
                    propsPanel.current.setVisible(true, props.balconyInfo.getGroup(id),
                        props.balconyInfo.propertyInfo, updateProperties, findGroupsByProperties, selectBalcony);
                }
            }
        }

        ownEvent.current = true;
        props.viewer.select([id], props.balconyInfo.getInfoNodeModel());
    }

    async function selectionListener({ selections }) {
        if (!ownEvent.current) {
            const nodeSel = _.find(selections, sel => sel.model.id === infoModelId.current);
            if (nodeSel != null) {
                await sleep(10);
                await selectBalcony(nodeSel.dbIdArray[nodeSel.dbIdArray.length - 1]);
            }
        }

        ownEvent.current = false;
    }

    const addBalcony = (apartment: string, level: number, line: string, panels: BalconyPanel[], drawPanels: boolean = false, meas = null) => {
        let properties: { [key: string]: string } = {
            Level: level.toString(),
            Apartment: apartment,
            BalconyLine: line
        };

        let group = props.balconyInfo.addGroupWithPanels(panels, properties);

        props.balconyInfo.drawGroupInfoNode(group);

        // Add panel width as balcony property
        // TODO: Separate panel metadata per panel
        for (var i = 0; i < panels.length; i++) {
            group.propertyValues[`GlazingWidth${i + 1}`] = group.formatValue(`GlazingWidth${i + 1}`, panels[i].baseLine.distance().toString());
        }

        // Add panel height as balcony property
        group.propertyValues["GlazingHeight"] = group.formatValue("GlazingHeight", panels[0].height.toString());

        group.updateNodeInfoToExternalData();

        if (meas)
            group.measurements = meas;

        if (drawPanels) group.drawPanels(props.balconyInfo.gfxUtilsPanels);

        const balcs = balconies.slice();
        balcs.push(group);
        setBalconies(balcs);
        selectBalcony(group.id);
        setStep(BalconyStep.None);
    }

    removeBalcony = async () => {
        propsPanel.current.setVisible(false);
        // We have to wait because props panel unmount takes awhile
        await sleep(10);

        props.viewer.clearSelection();
        props.balconyInfo.removeGroup(selectedBalconyId);
        await removeMeasurements();
        setBalconies(props.balconyInfo.groups.slice());
        setSelectedBalconyId(null);
    }

    const removePanels = (panels: number[]) => {
        props.viewer.clearSelection();
        panels.forEach((value) => {
            props.balconyInfo.gfxUtilsPanels.deleteNode(value);
        });
    }

    const startMeasurementCreation = () => {
        setStep(BalconyStep.Measurement);
    }

    const addMeasurements = (id: number, meas) => {
        props.balconyInfo.updateGroupMeasurements(id, meas);
        setStep(BalconyStep.None);
        selectBalcony(selectedBalconyId);
    }

    const initBalconyMeasurements = async (id: number) => {
        await removeMeasurements();

        let group = props.balconyInfo.getGroup(id);

        if (!group.measurements || _.isEmpty(group.measurements)) return;

        let meas = _.cloneDeep(group.measurements);

        const forgeMeasurements = meas.map(m => {
            const fm = {
                ...m,
                distance: `${m.value} ${m.unit}`
            }

            for (let pick of fm.picks) {
                pick.intersection = new THREE.Vector3(pick.intersection.x, pick.intersection.y, pick.intersection.z).toViewerUnits();
            }

            return fm;
        });

        const measExt = props.viewer.getExtension("Autodesk.Measure") as Autodesk.Extensions.Measure.MeasureExtension;

        measExt.activate("distance");
        measExt.setMeasurements(forgeMeasurements);
        measExt.deactivate();

        const measButton = $("#toolbar-measurementSubmenuTool");
        measButton.addClass("pulsing-highlight");
        measButton.on("click", () => measButton.removeClass("pulsing-highlight"));
    }

    async function removeMeasurements() {
        const measExt = props.viewer.getExtension("Autodesk.Measure") as Autodesk.Extensions.Measure.MeasureExtension;

        await sleep(5);

        measExt.activate("distance");

        let meas = measExt.getMeasurementList();
        if (meas.length > 0) {
            measExt.deleteMeasurements();
        }

        measExt.deactivate();

        const measButton = $("#toolbar-measurementSubmenuTool");
        measButton.removeClass("pulsing-highlight");
    }

    const startCopying = () => {
        setStep(BalconyStep.Copy);
    }

    const copyBalconies = (direction: number, offset: number, amount: number) => {
        let newGroups = props.balconyInfo.copyGroupWithZOffset(props.balconyInfo.getGroup(selectedBalconyId),
            direction * offset, amount);

        for (const group of newGroups) {
            props.balconyInfo.drawGroupInfoNode(group);
            group.updateNodeInfoToExternalData();
        }

        setBalconies((prev) => prev.concat(...newGroups));
        setStep(BalconyStep.None);
    }

    const openProperties = () => {
        propsPanel.current.setVisible(true, props.balconyInfo.getGroup(selectedBalconyId),
            props.balconyInfo.propertyInfo, updateProperties, findGroupsByProperties, selectBalcony);
    }

    const updateProperties = (balcony: BalconyGroup) => {
        balcony.updateNodeInfoToExternalData();

        props.balconyInfo.setUpdated();

        let balcIndex = balconies.findIndex(i => i.id === balcony.id);
        let updatedBalconies = [...balconies];
        updatedBalconies[balcIndex] = balcony;
        setBalconies(updatedBalconies);
    }

    const findGroupsByProperties = async (propId: string, propValue: string) => {
        return await props.balconyInfo.findMatchingGroups(propId, propValue);
    }

    function cleanExit() {
        removeMeasurements();
        propsPanel.current.setVisible(false);

        props.viewer.removeEventListener(Autodesk.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT,
            selectionListener);
    }

    useEffect(() => {
        props.viewer.addEventListener(Autodesk.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT,
            selectionListener);

        //// Hide all panels, just for easier testing
        //let model = props.viewer.getVisibleModels()[0];
        //let instanceTree = model.getInstanceTree();
        //const dbIds = Object.keys(instanceTree.nodeAccess.dbIdToIndex).map(id => Number(id));
        //for (var i = 0; i < dbIds.length; i++) {
        //    let name = instanceTree.getNodeName(dbIds[i]);
        //    if (name && name.startsWith("Lumon Railing")) {
        //        (props.viewer.impl.visibilityManager as any).setNodeOff(dbIds[i], false, model);
        //        props.viewer.hide(dbIds[i]);
        //    }
        //}

        const addPanelsModel = async () => {
            let modelNumber = await props.balconyInfo.gfxUtilsPanels.addModel();
            panelsModelId.current = modelNumber;
        };

        addPanelsModel();

        infoModelId.current = props.balconyInfo.getInfoNodeModelNumber();

        propsPanel.current = new BalconyPropertiesPanel(props.viewer, props.viewer.container, "SmartDrawings-Balcony-Properties");

        if (props.selectedBalconyId)
            selectBalcony(props.selectedBalconyId);

        return cleanExit;
    }, []);

    return (
        <div id="balcony-react" className="react-content m-2">
            <BalconyList balconies={balconies} selectedBalconyId={selectedBalconyId}
                startBalconyCreation={startBalconyCreation}
                removeBalcony={removeBalcony} removeAllBalconies={() => { }}
                selectBalcony={selectBalcony} startMeasurementCreation={startMeasurementCreation}
                startCopying={startCopying} openProperties={openProperties} />

            <hr className="bg-secondary py-1"></hr>
            {
                step === BalconyStep.Add &&
                <div>
                    <StartCreation viewer={props.viewer} originalModelId={1} panelsModelId={panelsModelId.current}
                        gfxUtils={props.balconyInfo.gfxUtilsPanels} addBalcony={addBalcony}
                        removePanels={removePanels} removeMeasurements={removeMeasurements} closeWizard={closeWizard} />
                </div>
            }
            {
                step === BalconyStep.Measurement &&
                <div>
                    <MeasurementSteps viewer={props.viewer} selectedBalconyId={selectedBalconyId}
                        originalModelId={1} panelsModelId={panelsModelId.current} gfxUtils={props.balconyInfo.gfxUtilsPanels}
                        addMeasurements={addMeasurements} initBalconyMeasurements={initBalconyMeasurements} closeWizard={closeWizard} />
                </div>
            }
            {
                step === BalconyStep.Copy &&
                <div>
                    <CopySteps viewer={props.viewer} selectedBalconyId={selectedBalconyId}
                        originalModelId={1} panelsModelId={panelsModelId.current} gfxUtils={props.balconyInfo.gfxUtilsPanels}
                        copyBalconies={copyBalconies} closeWizard={closeWizard} />
                </div>
            }
        </div>
    );
}

class GlassPanel extends Autodesk.Viewing.UI.DockingPanel {

    private viewer: Autodesk.Viewing.GuiViewer3D;
    private balconyInfo: BalconyInfo;

    private contentDiv: HTMLDivElement;
    private reactNode;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, balconyInfo: BalconyInfo, container: any, id: string) {
        super(container, id, "Construct glasses");
        this.viewer = viewer;
        this.balconyInfo = balconyInfo;

        this.container.classList.add("glasses-panel");
        this.container.classList.add("construct-panel");

        this.contentDiv = document.createElement("div");
        this.contentDiv.classList.add("content");
        this.container.appendChild(this.contentDiv);
    }

    setVisible(show: boolean, balconyId?: number) {
        super.setVisible(show);
        if (show) {
            unmountComponentAtNode(this.contentDiv);
            render(<GlassUi viewer={this.viewer} balconyInfo={this.balconyInfo} selectedBalconyId={balconyId} />, this.contentDiv);
        } else if (this.contentDiv) {
            unmountComponentAtNode(this.contentDiv);
            this.reactNode = null;
        }
    }

    removeSelectedBalcony() {
        removeBalcony();
    }
}

export { GlassPanel };